<template>
	<div class="content-box">
		<div style="height: 50px;display: flex;align-items: center;font-size: 14px;">
			订单管理-订单详情
		</div>
		<div style="width: 1170px;height: 200px;background: #FFFFFF;">
			<div style="height: 64px;margin: 0px 30px;border-bottom: 1px solid #efefef;" class="d-flex a-center">
				<div style="font-size: 14px;">交易成功</div>
				<div  style="font-size: 12px;margin-left: 26px;">订单实付：</div>
				<div  style="font-size: 12px;margin-left: 6px;color: #F33B17;"> {{datas.money_paid}} 元</div>
			</div>
			<div style="height: 40px;margin: 0px 30px;" class="d-flex a-center">
				<div style="display: flex;width: 400px;">
					<div  style="font-size: 12px;color: #888888;">订单号：</div>
					<div  style="font-size: 12px;margin-left: 6px;">{{datas.order_sn}}</div>
				</div>
				<div style="display: flex;">
					<div  style="font-size: 12px;color: #888888;">创建时间：</div>
					<div  style="font-size: 12px;margin-left: 6px;">{{datas.add_time_str}}</div>
				</div>
			</div>
			<div style="height: 40px;margin: 0px 30px;" class="d-flex a-center">
				<div style="display: flex;width: 400px;">
					<div  style="font-size: 12px;color: #888888;">产品：</div>
					<div  style="font-size: 12px;margin-left: 6px;">{{datas.goods_name}}</div>
				</div>
				<div style="display: flex;">
					<div  style="font-size: 12px;color: #888888;">支付时间：</div>
					<div  style="font-size: 12px;margin-left: 6px;">{{datas.pay_time_str}}</div>
				</div>
			</div>
			<div style="height: 40px;margin: 0px 30px;" class="d-flex a-center">
				<div style="display: flex;width: 400px;">
					<div  style="font-size: 12px;color: #888888;">订单类型：</div>
					<div  style="font-size: 12px;margin-left: 6px;">{{datas.order_type==1?'续费':'首开'}}</div>
				</div>
			</div>
		</div>
		<div v-if="datas.order_status==2" class="d-flex a-center" style="height: 50px;">
			<div @click="fcib_order_del" style="margin-left: auto;width: 114px;height: 26px;background: #1E69FF;
			border-radius: 4px;color: #FFFFFF;font-size: 14px;cursor: pointer;"
			class="d-flex a-center j-center">
				删除
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				datas:''
			}
		},
		created() {
			this.getOnsalegoods()
		},
		methods:{
			getOnsalegoods(){
				let param = {
					act : 'ep_order_info',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					order_id:this.$route.query.oid
				}
				this.$api.fcib_home_page_tpl_create(param).then((res)=>{
					this.datas= res.data
				})
			},
			fcib_order_del(){
				let param = {
					act : 'fcib_order_del',
					token: localStorage.getItem('token'),
					user_id: localStorage.getItem('user_id'),
					order_id:this.$route.query.oid
				}
				this.$api.fcib_home_page_tpl_create(param).then((res)=>{
					if(res.code == 0){
						this.$message({
							showClose: false,
							message: '删除成功',
							type: 'success',
							offset: 350
						})
						setTimeout(()=>{
							this.$router.back()
						},2000)
					}else{
						this.$message({
							showClose: false,
							message: res.msg,
							type: 'error',
							offset: 350
						})
					}
				})
			}
		}
	}
</script>

<style scoped>
	.content-box{
		height: 100%;
		max-width: 73.24rem;
		margin: 0 auto;
	}
</style>